<convfact-salary-form [salary]="salary" *ngIf="salary" [errors]="errors" (onSave)="saveData($event)"></convfact-salary-form>